<template>
  <div>
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-openeds="permission_routers.map(item => item.path + item.id)"
        :default-active="activePath"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        mode="vertical"
        router
      >
        <sidebar-item
          v-for="(route, index) in permission_routers"
          :key="route.path + index"
          :item="route"
          :superiors="route.path"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <!-- <div :class="[isCollapse ? 'isCollapse' : 'unCollapse', 'collapse']">
      <i class="el-icon-d-arrow-right" @click="toggleSideBar" v-if="isCollapse"></i>
      <i class="el-icon-d-arrow-left" @click="toggleSideBar" v-else></i>
    </div> -->
  </div>
</template>

<script>
import { mapGetters, mapActions, createNamespacedHelpers } from "vuex";
const { mapActions: appAtions } = createNamespacedHelpers("app");
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";

export default {
  components: { SidebarItem },
  data () {
    return {
      activePath: '',
      // activePathList: ['/videoList2', '/feedback3']
    }
  },
  computed: {
    ...mapGetters(["permission_routers", "sidebar"]),
    variables () {
      return variables;
    },
    isCollapse () {
      return !this.sidebar.opened;
    },
  },
  methods: {
    ...appAtions(["toggleSideBar"]),
  },
  created () {
    this.activePath = this.$route.path
  },
  watch: {
    "$route.path": function (newVal, oldVal) {
      this.activePath = newVal;
    }
  }
};
</script>

<style lang="scss" scoped>
// .collapse {
//   color: #000;
//   position: fixed;
//   z-index: 1002;
//   bottom: 10px;

//   text-align: center;
//   font-size: 24px;
// }

// .isCollapse {
//   width: 36px;
// }

// .unCollapse {
//   width: 280px;
// }
</style>
